/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MailParamsTelematicDeactivationTemplateData } from '../../models/mail-params-telematic-deactivation-template-data';
import { ResponseObject } from '../../models/response-object';

export interface SendTelematicDeactivationMail$Params {
      body: MailParamsTelematicDeactivationTemplateData
}

export function sendTelematicDeactivationMail(http: HttpClient, rootUrl: string, params: SendTelematicDeactivationMail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseObject>> {
  const rb = new RequestBuilder(rootUrl, sendTelematicDeactivationMail.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseObject>;
    })
  );
}

sendTelematicDeactivationMail.PATH = '/sendMail/telematic-deactivation';
